<template>
  <v-container fluid>
    <h1>Site Notes</h1>
    <ContentEditor />
    <ContentEditor />
  </v-container>
</template>

<script>
import ContentEditor from "../components/ContentEditor/ContentEditor.vue";
export default {
  name: "SiteNotes",
  route: {
    path: "/site-notes/",
    name: "Site Notes",
  },
  components: {
    ContentEditor,
  },
};
</script>

<style></style>
